import { GridItem, HStack, Image, Text, useTheme } from '@chakra-ui/react';
import React from 'react'
import { useAppContext } from '../../../App';
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { useState } from 'react';
import mesa6 from '../../../innerAsstes/elementos home web/Mesa de trabajo 6.png';
import { splitGivenDescription } from '../../../utils/functions';

export default function GridInspiredCard({ item, index }) {
  const { isMobile } = useAppContext();
  const theme = useTheme();
  const style = styles(theme, isMobile);
  const [openDrop, setOpenDrop] = useState(false);
  const [description, setDescription] = useState(splitGivenDescription(item.description));

  return (
    <GridItem
      key={item?.id || `inspired-card-${index}`}
      p={isMobile? 0 : '2vh'}
      display="flex"
      flexDirection={"column"}
      justifyContent="flex-start"
      alignItems="flex-start"
      width={"100%"}
      borderRadius={0}
      borderRightWidth={isMobile? 0 : index % 2 === 0 ? 1 : 0}
      borderBottomWidth={1}
      borderStyle={'dashed'}
    >
      <HStack
        width={"100%"}
        spacing={4}
        display={"flex"}
        alignSelf={"flex-start"}
        justifyContent={ isMobile? "space-between" : "flex-start"}
        onClick={() => setOpenDrop(!openDrop)}
      >
        <Image
          width={"5vh"}
          height={"5vh"}
          borderRadius={100}
          src={mesa6}
          alt={`img-inspired-card-${index}`}
        />
        <Text
          fontWeight="bold"
          textAlign={isMobile? "center" : "left"}
          fontSize={isMobile? "1.5rem" : "2rem"}
          color={theme.color.text.primary}
          className='sansation-bold'
        >
          {item.title}
        </Text>
        {openDrop ? (
          <ChevronDownIcon color={theme.color.text.secondary}  width={"4vh"} height={"4vh"} />
        ) : (
          <ChevronRightIcon color={theme.color.text.secondary}  width={"4vh"} height={"4vh"} />
        )}
      </HStack>
      {openDrop && (
        <div style={style.descriptionContainer} className='sansation-bold'>
          <Text style={style.description(1)} >
            {description.text1}
          </Text>
          <Text style={style.description(2)}>
            {description.text2}
          </Text>
        </div>
      )}
    </GridItem>
  );
}
const styles = (theme,isMobile) => ({
  container: {},
  descriptionContainer: {
    paddingTop: "2vh",
    paddingBottom: "2vh",
    paddingRight: "2vw",
    fontSize: "1rem",
    color: theme.color.text.tertiary,
  },
  description: (textNbr) => ({
    fontSize: isMobile? "1rem" : "2rem",
    lineHeight: 1.2,
    color: textNbr === 1? theme.color.text.secondary : theme.color.text.primary
  })
});